import { render, staticRenderFns } from "./ReviewIssueDeductionPullout.vue?vue&type=template&id=3f5b3607&scoped=true&"
import script from "./ReviewIssueDeductionPullout.vue?vue&type=script&lang=js&"
export * from "./ReviewIssueDeductionPullout.vue?vue&type=script&lang=js&"
import style0 from "./ReviewIssueDeductionPullout.vue?vue&type=style&index=0&id=3f5b3607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b3607",
  null
  
)

export default component.exports